import { Component, OnInit, OnDestroy, HostListener, Injector, effect } from '@angular/core';
import { MenuItem, MenuService } from '../services/menu.service';
import { resolveMenuIcon } from '../services/menu-icons';
import { ModuleVersionService } from '../../app/services/module-version.service';
import { VAZHIPADU_MODULE } from '../../app/services/module-version-menu';
import { VenueModuleService } from '../../app/services/venue-module.service';
@Component({
    // tslint:disable-next-line:component-selector
    selector: 'nav-menu,[nav-menu]',
    templateUrl: './nav-menu.component.html',
    styleUrls: ['./nav-menu.component.css'],
    providers: [MenuService],
    standalone: false
})
export class NavMenuComponent implements OnInit, OnDestroy {
  constructor(public menuService: MenuService,
    private moduleVersionService: ModuleVersionService,
    private venueModuleService: VenueModuleService,
    private injector: Injector) {

  }

  ngOnInit() {
    this.menuService.setMenuITEMS();
    // Workstream E phase 2: fetch the per-temple module versions (no-op when
    // already loaded) and rebuild the menu whenever a version changes - a
    // save in Settings > Module Versions re-wires this window's menu live;
    // other counters pick it up at their next login/menu build.
    this.moduleVersionService.ensureLoaded().subscribe();
    effect(() => {
      this.moduleVersionService.version(VAZHIPADU_MODULE)();
      this.menuService.setMenuITEMS();
    }, { injector: this.injector });
    // WS-FHP: same shape for the AUDITORIUM/FUNCTION_HALL venue switch — fetch
    // it once (never toasts/loader-spins: WithoutInterceptor, and a 403 for a
    // user without the function-hall roles simply leaves the default) and
    // rebuild the menu when a Settings save changes it.
    this.venueModuleService.ensureLoaded().subscribe();
    effect(() => {
      this.venueModuleService.venueModule();
      this.menuService.setMenuITEMS();
    }, { injector: this.injector });
  }

  /** Relevant FA4 icon (no `fa-` prefix) for a top-level or sub-menu item. */
  iconFor(item: MenuItem): string {
    return resolveMenuIcon(item);
  }

  /**
   * The dropdown-vs-megamenu decision and the megamenu column chunking both
   * derive from the viewport height (MenuService.rowsPerColumn), so a resize
   * rebuilds the menu (debounced) - a shrunken window flows the overflow
   * into an extra column, a grown one collapses it back.
   */
  private resizeTimer: any = null;

  @HostListener('window:resize')
  onWindowResize(): void {
    clearTimeout(this.resizeTimer);
    this.resizeTimer = setTimeout(() => this.menuService.setMenuITEMS(), 250);
  }

  ngOnDestroy(): void {
    clearTimeout(this.resizeTimer);
  }

  /**
   * Hover menus stay open under the cursor; when a leaf item (sub-menu or
   * mega-menu link) is clicked we collapse the panel so it doesn't linger over
   * the freshly-navigated screen. `dismissed` force-hides the panels via CSS;
   * it is cleared on mouseleave so the next hover opens normally.
   */
  dismissed = false;

  onMenuClick(ev: Event): void {
    const el = ev.target as HTMLElement;
    const link = el?.closest?.('a');
    if (link && link.closest('.sub-menu, .mega-menu')) {
      this.dismissed = true;
      (document.activeElement as HTMLElement)?.blur?.();
    }
  }
}
